import {atom} from "recoil";

export const selectedCreditCardState = atom({
  key: 'SelectedCreditCardState',
  default: null,
  effects: []
});
